import { ChiptaElement, html } from 'chipta-libs/main.js';
import URLSearchParams from '@ungap/url-search-params'
import './ticketshop-footer.js';

class TicketshopShell extends ChiptaElement {

  render() {

    return html`

      <div class="shell" style=${this.shellStyle}>

        <div class="contents">
          <slot></slot>
        </div>

        <div class="footer-spacer"></div>
        <ticketshop-footer></ticketshop-footer>

      </div>

      <style>

        :host {
            width: 100%;
        }

        .shell {
          display: flex;
          flex-direction: column;
          min-height: 100%;
        }

        .footer-spacer {
          flex-grow: 1;
        }

        @media screen and (max-width: 500px) {

          :host {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
          }

          .shell {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
          }

          .contents {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
          }

          .footer-spacer,
          ticketshop-footer {
            display: none;
          }

        }

      </style>

    `;

  }

  get shellStyle() {
    return 'background: ' + this.backgroundColor + ';';
  }

  get backgroundColor() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('transparent-background')) {
      return 'transparent';
    } else {
      return _themeData.background_color;
    }
  }

}

customElements.define('ticketshop-shell', TicketshopShell);
